export default {
    interactionName: state => state.interactionName,
    resultsUser: state => state.instanceDashboardResults && state.instanceDashboardResults.user,
    esgResults: state => state.esgResults
}
